import { REDEEM_OTP } from "../constants";
import type { LoyaltyProviderProfile } from "./types";

/**
 * The baseline: an ordinary points partner.
 *
 * 🔴 **Every unregistered `metaId` gets this**, which is what makes a provider the merchant
 * enables tomorrow safe rather than a crash or a blank panel. It describes the majority shape —
 * points in, money off, an OTP to confirm, capped at what the bill is worth — and says "no" to
 * every capability that only a specific partner has.
 *
 * Today `reelo`, `mloyal` and anything unlisted run on exactly this and have no file of their own.
 * Give a provider a profile only when it actually differs.
 */
export const defaultProfile: LoyaltyProviderProfile = {
  metaId: "default",

  supportsPointsRedemption: true,
  publishesProgram: false,
  requiresLiveProgramToRedeem: false,
  // A partner with no programme has published no caps, so the bill is the ceiling.
  capsOwnRedemption: false,
  usesProgramRedemptionValue: false,
  redeemOtpLength: REDEEM_OTP.DEFAULT_LENGTH,
  loyaltyDetailsFetchMode: undefined,
  supportsItemExclusions: false,

  // Only dotpe and xeno have the consent endpoints behind them; see the field's docs.
  supportsEnrollmentConsent: false,
  requiresLiveProgramForConsent: false,
  honoursSkipEnrollmentOtp: false,

  membershipStatusField: undefined,
};

/** Build a profile from the baseline. Only the deltas belong in a provider's file. */
export const defineProfile = (
  metaId: string,
  overrides: Partial<Omit<LoyaltyProviderProfile, "metaId">>,
): LoyaltyProviderProfile => ({ ...defaultProfile, metaId, ...overrides });
